import { Box, Icon, Text } from '@medely/ui-kit';
import React from 'react';
import { JobDetailsListItem } from '../../JobDetailsListItem';
import { ShiftLocation } from '../../ShiftLocation';
import { ShiftDate } from '../../ShiftDate';
import { DisplayHelpers } from '@mp/utils';
import { AvailableGeneralInfoProps } from './interface';
import { JobDetailsFragment } from '../graphql';
import { parseFragmentData } from '@mp/graphql/generated';

export const AvailableGeneralInfo = ({
  job: inputJob,
  smallIcon,
  isSaas,
  coordinates,
  isAgency,
  bookedOrInProgressOrCompleted,
}: AvailableGeneralInfoProps) => {
  const job = parseFragmentData(JobDetailsFragment, inputJob);

  return (
    <>
      <Box py={1}>
        <JobDetailsListItem
          icon={
            <Icon
              name="light-hospital"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
          title="Location"
        >
          <ShiftLocation
            job={inputJob}
            bookVariant={
              !bookedOrInProgressOrCompleted || isSaas || isAgency ? 'pre-book' : 'post-book'
            }
            distanceVariant="local"
            userCoordinates={coordinates}
          />
        </JobDetailsListItem>
      </Box>
      <Box py={1}>
        <JobDetailsListItem
          icon={
            <Icon
              name="light-calendar"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
          title="Date"
        >
          <ShiftDate job={inputJob} displayStartingSoonBadge />
        </JobDetailsListItem>
      </Box>
      <Box py={1}>
        <JobDetailsListItem
          icon={
            <Icon
              name="light-clock"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
          title="Shift time"
        >
          <Text size="m">
            {DisplayHelpers.job.timeFormatted(
              job?.current_ends_time,
              job?.current_starts_time,
              job?.approved_clock_in,
              job?.approved_clock_out,
              job?.location?.timezone_lookup,
              job?.guaranteed_minimum_hours,
              job?.status,
            )}
          </Text>
        </JobDetailsListItem>
      </Box>
    </>
  );
};
